import React, { useState } from "react";
import LandingHeader from "./LandingHeader";
import LandingFooter from "./LandingFooter";
import Hero from "./LandingHero";

const testimonials = [  
  {
  
    name: "Jessica M.",
    title: {
      en: "Marketing Manager",
      ar: "مديرة تسويق",
    },
    quote: {
      en: "Chatty reshaped the way we handle support. Replies are instant, accurate, and our CSAT climbed every single month.",
      ar: "شاتّي غيّر طريقتنا في تقديم الدعم. الردود أصبحت فورية ودقيقة، وارتفع رضا العملاء لدينا كل شهر.",
    },
    service: {
      en: "Paired the chatbot with our concierge onboarding and WhatsApp automation to cover every touch point.",
      ar: "جمعنا الروبوت مع خدمة الإطلاق المخصصة وأتمتة واتساب لتغطية كل نقاط التواصل.",
    },
  },
  {
   
    name: "David L.",
    title: {
      en: "E-commerce Founder",
      ar: "مؤسس تجارة إلكترونية",
    },
    quote: {
      en: "Automation plus the live handoff service lifted conversions by 30%. We act on leads the moment they appear.",
      ar: "الأتمتة مع خدمة التحويل للمشغلين رفعت التحويلات بنسبة 30%. نعالج العملاء المحتملين فور ظهورهم.",
    },
    service: {
      en: "Uses Chatty analytics, live agent routing, and proactive campaigns to nurture high-intent shoppers.",
      ar: "نستخدم تحليلات شاتّي وتوجيه الوكلاء والحملات الاستباقية لرعاية المتسوقين ذوي النية العالية.",
    },
  },
  {
   
    name: "Sarah K.",
    title: {
      en: "Operations Director",
      ar: "مديرة العمليات",
    },
    quote: {
      en: "The platform is intuitive, but the integration studio sealed the deal. We automated follow-ups right inside our CRM.",
      ar: "المنصة سهلة، لكن استوديو التكامل كان العامل الحاسم. أتممنا المتابعة داخل نظام إدارة العلاقات مباشرة.",
    },
    service: {
      en: "Expanded with our integration studio and knowledge base sync to keep every conversation personalized.",
      ar: "توسعنا باستخدام استوديو التكامل ومزامنة قاعدة المعرفة للحفاظ على كل محادثة شخصية.",
    },
  },
];

const serviceHighlights = [
  {
    category: {
      en: "Onboarding",
      ar: "الإعداد",
    },
    title: {
      en: "Concierge Launch Program",
      ar: "برنامج الإطلاق المخصص",
    },
    description: {
      en: "We configure playbooks, channels, and training sessions so your team launches with confidence.",
      ar: "نقوم بإعداد القوالب والقنوات وجلسات التدريب ليبدأ فريقك بثقة.",
    },
  },
  {
    category: {
      en: "Support",
      ar: "الدعم",
    },
    title: {
      en: "Managed Live Agents",
      ar: "وكلاء مباشرون مدارون",
    },
    description: {
      en: "Blend automation with human specialists who jump in 24/7 for escalations and VIP care.",
      ar: "نمْزِج الأتمتة مع مختصين بشريين جاهزين للتدخل على مدار الساعة للحالات الحرجة ورعاية العملاء المميزين.",
    },
  },
  {
    category: {
      en: "Integrations",
      ar: "التكاملات",
    },
    title: {
      en: "Integration Studio",
      ar: "استوديو التكامل",
    },
    description: {
      en: "Connect your CRM, payment systems, and data warehouse so every workflow stays in sync.",
      ar: "صل نظام إدارة العملاء وأنظمة الدفع ومستودع البيانات لضمان تزامن كل سير عمل.",
    },
  },
];

const howItWorksSteps = [
  {
    image: "Button-min.png",
    title: {
      en: "Sign Up for Free",
      ar: "سجّل مجانًا",
    },
    description: {
      en: "Create your account in seconds. No credit card required. Just sign up and you’re ready to go.",
      ar: "أنشئ حسابك خلال ثوانٍ من دون الحاجة إلى بطاقة ائتمان، وابدأ فورًا.",
    },
  },
  {
    image: "Button-1-min.png",
    title: {
      en: "Connect Your Channels",
      ar: "وصّل قنواتك",
    },
    description: {
      en: "Integrate with your favorite platforms like WhatsApp, Messenger, and more with just a few clicks.",
      ar: "اربط منصاتك المفضلة مثل واتساب وفيسبوك ماسنجر والمزيد ببضع نقرات.",
    },
  },
  {
    image: "Button-2-min.png",
    title: {
      en: "Start Automating",
      ar: "ابدأ الأتمتة",
    },
    description: {
      en: "Begin building your chatbot, setting up automated responses, and engaging with your customers instantly.",
      ar: "ابدأ ببناء روبوتك، وإعداد الردود التلقائية، والتفاعل مع عملائك فورًا.",
    },
  },
];

const features = [
  {
    icon: "b20b00ef-37e6-4166-8f9e-ba83cbb20001.svg",
    title: { en: "24/7 Availability", ar: "متوفر 24/7" },
    description: {
      en: "Always online for instant assistance, enhancing productivity and ensuring support whenever you need it.",
      ar: "متوفر دائماً للمساعدة الفورية، مما يعزز الإنتاجية ويضمن الدعم في أي وقت تحتاجه."
    },
  },
  {
    icon: "69dfdb39-6b5f-42f9-818a-dce3c0578615.svg",
    title: { en: "Instant Responses", ar: "استجابات فورية" },
    description: {
      en: "Get answers in seconds, reducing wait times and improving overall efficiency in your interactions.",
      ar: "احصل على إجابات في ثوانٍ، مما يقلل من أوقات الانتظار ويحسن الكفاءة العامة في تواصلك."
    },
  },
  {
    icon: "ca375414-271c-4840-acc6-349bf957a7d3.svg",
    title: { en: "Personalized Interactions", ar: "تفاعلات مخصصة" },
    description: {
      en: "Adapts to your preferences, delivering tailored experiences that meet your unique needs and expectations.",
      ar: "يتكيف مع تفضيلاتك، ويقدم تجارب مصممة خصيصاً لتلبية احتياجاتك وتوقعاتك الفريدة."
    },
  },
  {
    icon: "a7c5fd6b-3ef5-4447-b2a4-55c8c170d446.svg",
    title: { en: "Task Automation", ar: "أتمتة المهام" },
    description: {
      en: "Streamline up to 70% of routine tasks, freeing up time for more important activities and boosting productivity.",
      ar: "يؤتمت حتى 70% من المهام الروتينية، مما يوفر وقتك للمهام الأكثر أهمية ويزيد الإنتاجية."
    },
  },
  {
    icon: "9ccedca6-7486-4ad6-a1c7-036405984356.svg",
    title: { en: "Scalable for All Needs", ar: "قابل للتوسع لجميع الاحتياجات" },
    description: {
      en: "Designed to accommodate diverse requirements, from personal use to comprehensive customer support solutions.",
      ar: "مصمم ليتناسب مع مختلف الاحتياجات، من الاستخدام الشخصي إلى حلول دعم العملاء الشاملة."
    },
  },
  {
    icon: "ab51bf30-d4d9-4d16-9a49-04e3e2253602.svg",
    title: { en: "Continuous Learning", ar: "تعلم مستمر" },
    description: {
      en: "Improves with every interaction, offering smarter solutions and enhanced performance over time for users.",
      ar: "يتحسن مع كل تفاعل، ويقدم حلولاً أكثر ذكاءً وأداءً أفضل مع مرور الوقت للمستخدمين."
    },
  },
];

const fadeDownStyle = `
@keyframes fadeDown {
  0% {
    opacity: 0;
    transform: translateY(-40px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.fade-down {
  animation: fadeDown 1s cubic-bezier(0.23, 1, 0.32, 1) both;
}
`;

const translations = {
  ar: {
    features: "المميزات",
    discover: "اكتشف قوة واتسي",
    featuresDesc: "اكتشف روبوت الدردشة الذكي الموثوق به من قبل أكثر من 10,000 مستخدم، يقدم دعمًا على مدار الساعة ويقوم بأتمتة حتى 70% من المهام الروتينية. احصل على ردود أسرع بنسبة 90% واستمتع بمساعدة مخصصة لجعل كل تفاعل سلسًا.",
    howItWorks: "كيف يعمل",
    howItWorksTitle: "خطوات سهلة للبدء",
    howItWorksDesc: "منصتنا مصممة للبساطة. ابدأ في دقائق وغيّر تواصلك مع العملاء.",
    statsTitle: "واتسي يساعد آلاف المستخدمين",
    statsJourney: "نحن فقط في بداية رحلتنا",
    stats: [
      { value: "10+", label: "مستخدم نشط حول العالم" },
      { value: "1K+", label: "ردود يومية" },
      { value: "0.01ث", label: "متوسط زمن الرد" },
      { value: "10+", label: "تقييم 5 نجوم" }
    ],
    pricing: "الأسعار والباقات",
    pricingDesc: "باقات بسيطة وشفافة. ابدأ مجانًا وطور حسب احتياجك.",
    free: "أساسي",
    pro: "مميز",
    business: "بزنس",
    year: "سنة",
    months3: "3 شهور",
    priceDollar: "دولار",
    dailyPoints: "النقاط اليومية",
    pointMsg: "1 نقطة = 1 رسالة",
    support: "دعم فني",
    hot: "الأكثر طلباً",
    testimonials: "آراء العملاء",
    testimonialsTitle: "ماذا يقول عملاؤنا",
    testimonialsDesc: "يثق بنا آلاف العملاء السعداء. إليك بعض آرائهم حول تجربتهم مع منصتنا.",
  testimonialsServicesTitle: "خدمات أخرى تعزز نجاحك",
  testimonialsServicesDesc: "نرافقك في كل خطوة من خلال الإعداد المخصص، والدعم البشري المتواصل، والتكاملات الذكية التي تبقي عملك متصلاً.",
    getStarted: "ابدأ مجانًا",
    ready: "جاهز لتحويل تواصلك مع العملاء؟",
    readyDesc: "انضم إلى آلاف الشركات التي تستخدم روبوت الدردشة الذكي لدينا لتعزيز الدعم وزيادة المبيعات.",
  },
  en: {
    features: "FEATURES",
    discover: "Discover the Power of Chatty",
    featuresDesc: "Experience the AI ChatBot trusted by over 10,000 users, delivering 24/7 support and automating up to 70% of routine tasks. Get responses 90% faster and enjoy personalized assistance, tailored to make every interaction seamless.",
    howItWorks: "HOW IT WORKS",
    howItWorksTitle: "A Few Easy Steps to Start",
    howItWorksDesc: "Our platform is designed for simplicity. Get up and running in just a few clicks and start transforming your customer interactions.",
    statsTitle: "Chatty helping thousands of users",
    statsJourney: "We’re only just getting started on our journey",
    stats: [
      { value: "500K+", label: "Active users worldwide" },
      { value: "100M+", label: "Chat responses every day" },
      { value: "0.01sec", label: "Average response time" },
      { value: "100K+", label: "5-star reviews" }
    ],
    pricing: "PRICING",
    pricingDesc: "Simple, transparent pricing. No hidden fees. Start for free, upgrade when you’re ready.",
    free: "Basic",
    pro: "Pro",
    business: "Business",
    year: "1 Year",
    months3: "3 Months",
    priceDollar: "USD",
    dailyPoints: "Daily Points",
    pointMsg: "1 point = 1 message",
    support: "Support",
    hot: "HOT",
    testimonials: "TESTIMONIALS",
    testimonialsTitle: "What Our Customers Say",
    testimonialsDesc: "We are trusted by thousands of happy customers. Here’s what some of them have to say about their experience with our platform.",
  testimonialsServicesTitle: "More Ways We Support Your Growth",
  testimonialsServicesDesc: "From white-glove onboarding to managed agents and deep integrations, we make sure every customer touch point feels effortless.",
    getStarted: "Get Started for Free",
    ready: "Ready to Transform Your Customer Engagement?",
    readyDesc: "Join thousands of businesses already using our AI chatbot to enhance their customer support and automate their sales.",
  }
};

export default function LandingPage() {
  const [lang, setLang] = useState("ar");
  const t = translations[lang];
  const [billingCycle, setBillingCycle] = useState("monthly");

  const partnerLogos = [
    "logo-1.png",
    "logo-2.png",
    "logo-3.png",

    "logo-5.png",

  ];

  const planPerks = (pointsValue) => [
    { label: t.dailyPoints, value: pointsValue },
    { label: t.pointMsg },
    { label: t.support },
  ];

  const cycleNotes = {
    monthly: lang === "ar" ? "مرونة بالدفع الشهري" : "Flexible month-to-month commitment",
    quarterly: lang === "ar" ? "توازن مثالي يُفوتر كل 3 أشهر" : "Balanced every-3-months cadence",
    annual: lang === "ar" ? "وفر 25% عند الدفع السنوي" : "Save 25% with annual billing",
  };

  const billingOptions = [
    { id: "monthly", label: lang === "ar" ? "شهري" : "Monthly" },
    { id: "quarterly", label: lang === "ar" ? "ربع سنوي" : "Quarterly" },
    { id: "annual", label: lang === "ar" ? "سنوي" : "Annual" },
  ];

  const pricingPlans = [
    {
      id: "basic-annual",
      tier: "basic",
      title: `${t.free} ${t.year}`,
      price: "135",
      period: t.priceDollar,
      perks: planPerks("900"),
      cycle: "annual",
      note: cycleNotes.annual,
    },
    {
      id: "basic-quarter",
      tier: "basic",
      title: `${t.free} ${t.months3}`,
      price: "35",
      period: t.priceDollar,
      perks: planPerks("700"),
      cycle: "quarterly",
      note: cycleNotes.quarterly,
    },
    {
      id: "basic-monthly",
      tier: "basic",
      title: t.free,
      price: "15",
      period: t.priceDollar,
      perks: planPerks("500"),
      cycle: "monthly",
      note: cycleNotes.monthly,
    },
    {
      id: "pro-annual",
      tier: "pro",
      title: `${t.pro} ${t.year}`,
      price: "195",
      period: t.priceDollar,
      perks: planPerks("2000"),
      cycle: "annual",
      note: cycleNotes.annual,
      featured: true,
    },
    {
      id: "pro-quarter",
      tier: "pro",
      title: `${t.pro} ${t.months3}`,
      price: "50",
      period: t.priceDollar,
      perks: planPerks("1500"),
      hot: t.hot,
      featured: true,
      cycle: "quarterly",
      note: cycleNotes.quarterly,
    },
    {
      id: "pro-monthly",
      tier: "pro",
      title: t.pro,
      price: "20",
      period: t.priceDollar,
      perks: planPerks("1200"),
      cycle: "monthly",
      note: cycleNotes.monthly,
      featured: true,
    },
    {
      id: "business-annual",
      tier: "business",
      title: `${t.business} ${t.year}`,
      price: "295",
      period: t.priceDollar,
      perks: planPerks("8000"),
      cycle: "annual",
      note: cycleNotes.annual,
    },
    {
      id: "business-quarter",
      tier: "business",
      title: `${t.business} ${t.months3}`,
      price: "75",
      period: t.priceDollar,
      perks: planPerks("4200"),
      cycle: "quarterly",
      note: cycleNotes.quarterly,
    },
    {
      id: "business-monthly",
      tier: "business",
      title: t.business,
      price: "30",
      period: t.priceDollar,
      perks: planPerks("3000"),
      cycle: "monthly",
      note: cycleNotes.monthly,
    },
  ];

  const filteredPlans = pricingPlans.filter((plan) => plan.cycle === billingCycle);

  const ctaHighlights =
    lang === "ar"
      ? [
          "لا حاجة لبطاقة ائتمان",
          "دعم مباشر على مدار الساعة",
          "تجربة إعداد شخصية",
        ]
      : [
          "No credit card required",
          "24/7 live specialists",
          "White-glove onboarding",
        ];

  const ctaSecondaryLabel = lang === "ar" ? "تعرّف على الباقات" : "Explore plans";
  const ctaBadgeLabel = lang === "ar" ? "حل شامل" : "All-in-one platform";
  const ctaBadgeClass = lang === "ar" ? "tracking-normal" : "tracking-[0.35em] uppercase";

  const featureAccentGradients = [
    "from-sky-400/15 via-blue-500/10 to-transparent",
    "from-purple-400/20 via-indigo-500/10 to-transparent",
    "from-emerald-400/20 via-teal-500/10 to-transparent",
  ];

  const featureIconAccents = [
    "from-sky-500/30 via-sky-400/40 to-blue-500/40",
    "from-indigo-500/30 via-purple-500/40 to-blue-600/40",
    "from-emerald-500/30 via-teal-500/40 to-green-600/40",
  ];

  return (
    <div
    dir={
lang === "ar" ? "rtl" : ""
    }
     className={`bg-gray-50  text-white `}>

      <style>
        {fadeDownStyle}
        {`
          /* Primary brand color centralized */
          :root {
            --color-primary: #0E91A5; /* refreshed teal for better contrast */
            --color-primary-700: #0b6f7b;
            --color-accent: #6FE3F2;
          }
          .text-main { color: var(--color-primary); }
          .bg-main { background-color: var(--color-primary); }
          .border-main { border-color: var(--color-primary); }
          .from-main { --tw-gradient-from: var(--color-primary); }
          .to-main { --tw-gradient-to: var(--color-primary); }
          .via-main { --tw-gradient-stops: var(--tw-gradient-from), var(--color-primary), var(--tw-gradient-to); }
        `}
      </style>
      {/* Language Switcher */}
    
      <LandingHeader lang={lang} setLang={setLang} />
      <main>
        <Hero partnerLogos={partnerLogos} lang={lang} t={t} />

        <section id="features" className="relative overflow-hidden py-20 sm:py-32">
         
          <div className="container relative z-10 mx-auto px-4 text-center">
            <div className="mb-12 space-y-4">
              <span className="inline-flex items-center justify-center gap-3 rounded-full border border-main/20 bg-white/60 px-4 py-1 text-xs font-semibold uppercase tracking-[0.35em] text-main shadow-sm shadow-main/10 ">
                {t.features}
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 ">
                <span className="bg-gradient-to-r from-main via-sky-500 to-main bg-clip-text text-transparent">
                  {t.discover}
                </span>
              </h2>
              <p className="text-gray-600  max-w-3xl mx-auto text-base md:text-lg">
                {t.featuresDesc}
              </p>
            </div>
            <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
              {features.map((feature, index) => {
                const cardAccent = featureAccentGradients[index % featureAccentGradients.length];
                const iconAccent = featureIconAccents[index % featureIconAccents.length];
                return (
                  <div
                    key={feature.title.en}
                    className="group relative overflow-hidden rounded-3xl border border-slate-200/70 bg-white/95 p-8  shadow-lg shadow-main/10 transition duration-300 hover:-translate-y-2 hover:border-main/40 hover:shadow-2xl hover:shadow-main/20 "
                  >
                    <div className={`pointer-events-none absolute inset-0 -z-10 bg-gradient-to-br ${cardAccent} opacity-0 transition duration-300 group-hover:opacity-100 `}></div>
                    <div className="pointer-events-none absolute -top-20 right-0 h-36 w-36 rounded-full bg-main/10 blur-3xl transition duration-300 group-hover:bg-main/20 "></div>
                    <div className="relative mb-6 inline-flex h-14 w-14 items-center justify-center rounded-2xl border border-white/60 bg-white/80 p-3 shadow-lg shadow-main/10 transition duration-300 group-hover:scale-105 ">
                      <span className={`absolute -inset-1 rounded-2xl bg-gradient-to-br ${iconAccent} opacity-70 blur-md`}></span>
                      <span className="absolute inset-0 rounded-2xl bg-white/50 "></span>
                      <img
                        src={`/landing/${feature.icon}`}
                        alt={feature.title[lang]}
                        className="relative z-10 h-8 w-8 transition-all duration-300 group-hover:scale-110"
                      />
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 ">
                      {feature.title[lang]}
                    </h3>
                    <p className="mt-3 text-gray-600 ">
                      {feature.description[lang]}
                    </p>
                    <div className="mt-6 h-px w-full bg-gradient-to-r from-transparent via-slate-200/70 to-transparent "></div>
                    <div className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-main/80 transition duration-300 group-hover:text-main" >
                     
                      <span className="text-main">

               
                        {lang === "ar" ? "استكشف التفاصيل" : "Discover the details"}
                      </span>
                       <span className="flex h-6 w-6 items-center justify-center rounded-full bg-main/10 text-main  ">
                        <svg
                          aria-hidden="true"
                          className="h-3.5 w-3.5"
                          fill="none"
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2.2"
                          viewBox="0 0 24 24"
                        >
                      <path d="M5 12h14M13 6l6 6-6 6" />
                        </svg>
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        <section
          id="how-it-works"
          className="relative overflow-hidden bg-white pb-20 sm:pb-32"
        >
          <div className="absolute inset-0 pointer-events-none bg-gradient-to-b from-slate-100/60 via-white to-slate-50/40"></div>
          <div className="container relative z-10 mx-auto px-4">
            <div className="mb-12 space-y-4 text-center">
              <span className="inline-flex items-center justify-center gap-3 rounded-full border border-main/20 bg-white/80 px-4 py-1 text-xs font-semibold uppercase tracking-[0.35em] text-main shadow-sm shadow-main/10">
                {t.howItWorks}
              </span>
              <h2 className="text-3xl font-bold text-gray-900 md:text-4xl">
                {t.howItWorksTitle}
              </h2>
              <p className="mx-auto max-w-3xl text-base text-gray-600 md:text-lg">
                {t.howItWorksDesc}
              </p>
            </div>
            <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
              {howItWorksSteps.map((step, index) => (
                <div
                  key={step.title.en}
                  className="relative flex h-full flex-col gap-4 rounded-3xl border border-slate-200/70 bg-white/95 p-8 shadow-lg shadow-main/10 transition duration-300 hover:-translate-y-2 hover:shadow-2xl"
                  style={{ animation: `fadeDown 0.9s ${index * 0.12}s both` }}
                >
                  <div className="flex items-center justify-between gap-4">
                    <div className="flex items-center gap-4">
                      <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-main/15 text-lg font-semibold text-main">
                        {String(index + 1).padStart(2, "0")}
                      </span>
                      <h3 className="text-xl font-bold text-gray-900">
                        {step.title[lang]}
                      </h3>
                    </div>
                    <img
                      src={`/landing/${step.image}`}
                      alt={step.title[lang]}
                      className="h-12 w-12 flex-shrink-0 rounded-xl border border-slate-200/60 bg-white object-contain p-2 shadow-sm"
                    />
                  </div>
                  <p className="text-gray-600">
                    {step.description[lang]}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section
          id="numbers"
          className="py-20 sm:py-32 bg-gradient-to-br from-[#071B29] via-[#0B2236] to-[#013D4E] text-white relative overflow-hidden"
        >
          {/* Decorative gradient circles */}
          <div className="absolute top-0 left-0 w-72 h-72 bg-blue-900/30 rounded-full blur-3xl -z-10"></div>
          <div className="absolute bottom-0 right-0 w-72 h-72 bg-sky-400/20 rounded-full blur-3xl -z-10"></div>
          <div className="container mx-auto px-4 flex flex-col items-center justify-center gap-12">
            <div className="mb-8 text-center">
              <p className="font-semibold tracking-widest mb-2 text-main text-lg">
                {t.statsTitle}
              </p>
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 drop-shadow-lg text-white">
                {t.statsJourney}
              </h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 mt-8 w-full max-w-4xl">
              {t.stats.map((stat, i) => (
                <div
                  key={i}
                  className="bg-gradient-to-tr from-[#0B2236] via-[#013D4E]/60 to-[#6FE3F2]/10 rounded-2xl p-8 flex flex-col items-center shadow-2xl border border-blue-900/30 hover:scale-105 transition-transform duration-300 relative"
                  style={{ animation: `fadeDown 0.8s ${i * 0.15}s both` }}
                >
                  {/* Example icons, you can replace with actual SVGs or images */}
                  <div className="mb-4">
                    <span className="inline-block bg-main/20 p-4 rounded-full">
                      <svg width="32" height="32" fill="none" viewBox="0 0 32 32">
                        <circle cx="16" cy="16" r="14" stroke="#6FE3F2" strokeWidth="3" fill="none" />
                        <text x="16" y="21" textAnchor="middle" fontSize="16" fill="#6FE3F2" fontWeight="bold">{i+1}</text>
                      </svg>
                    </span>
                  </div>
                  <span className="text-4xl sm:text-5xl font-extrabold text-[#6FE3F2] drop-shadow-lg animate-pulse">
                    {/* Animated counter */}
                    <AnimatedCounter
                      value={stat.value}
                      locale={lang === "ar" ? "ar" : "en-US"}
                    />
                  </span>
                  <span className="mt-2 text-white/90 text-lg font-medium">{stat.label}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="pricing" className="relative overflow-hidden py-20 sm:py-32">
          <div
            aria-hidden="true"
            className="absolute inset-0 bg-gradient-to-b from-white via-slate-50/80 to-white "
          ></div>
          <div
            aria-hidden="true"
            className="pointer-events-none absolute inset-x-6 top-24 mx-auto h-64 max-w-5xl rounded-full bg-gradient-to-r from-main/20 via-sky-300/10 to-transparent blur-3xl opacity-70 "
          ></div>
          <div className="pointer-events-none absolute -top-32 -left-20 h-64 w-64 rounded-full bg-main/10 blur-3xl "></div>
          <div className="pointer-events-none absolute -bottom-36 right-0 h-72 w-72 rounded-full bg-sky-200/40 blur-3xl "></div>
          <div className="relative container mx-auto px-4">
            <div className="text-center mb-12 max-w-3xl mx-auto">
              <span className="inline-flex items-center justify-center rounded-full border border-main/20 bg-white/80 px-4 py-1 text-xs font-semibold uppercase tracking-[0.35em] text-main shadow-sm">
                {t.pricing}
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900  mt-4">
                {t.ready}
              </h2>
              <p className="text-gray-600  mt-4 text-base md:text-lg">
                {t.pricingDesc}
              </p>
            </div>
            <div className="mt-8 flex justify-center">
              <div
                className="inline-flex items-center gap-1 rounded-full border border-main/20 bg-white/80 p-1 shadow-sm shadow-main/10"
                role="radiogroup"
                aria-label={lang === "ar" ? "خيارات الفوترة" : "Billing frequency"}
              >
                {billingOptions.map((option) => {
                  const isActive = option.id === billingCycle;
                  return (
                    <button
                      key={option.id}
                      type="button"
                      onClick={() => setBillingCycle(option.id)}
                      className={`relative rounded-full px-4 py-2 text-sm font-semibold transition focus-visible:outline   focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-main ${
                        isActive
                          ? "bg-main text-white shadow-lg shadow-main/20"
                          : "text-black hover:text-main"
                      }`}
                      role="radio"
                      aria-checked={isActive}
                      aria-controls="pricing-plans"
                    >
                      {option.label}
                    </button>
                  );
                })}
              </div>
            </div>
            <div
              id="pricing-plans"
              className="mt-12 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3"
            >
              {filteredPlans.map((plan, index) => (
                <PricingCard
                  key={plan.id}
                  {...plan}
                  labels={t}
                  delay={index * 0.08}
                />
              ))}
            </div>
          </div>
        </section>

        <section
          id="testimonials"
          className="relative overflow-hidden py-20 sm:py-32 bg-gradient-to-b from-[#071B29] via-[#0B2236] to-[#013D4E]"
        >
          <div className="pointer-events-none absolute -top-24 right-1/4 h-64 w-64 rounded-full bg-sky-400/30 blur-3xl"></div>
          <div className="pointer-events-none absolute -bottom-32 left-1/5 h-72 w-72 rounded-full bg-main/20 blur-3xl"></div>
          <div className="container relative z-10 mx-auto px-4">
            <div className="text-center mb-12">
              <p className="font-semibold tracking-widest text-main">
                {t.testimonials}
              </p>
              <h2 className="text-3xl md:text-4xl font-bold text-white mt-2">
                {t.testimonialsTitle}
              </h2>
              <p className="text-white/80 max-w-2xl mx-auto mt-4">
                {t.testimonialsDesc}
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {testimonials.map((testimonial, index) => (
                <figure
                  key={testimonial.name}
                  className="relative flex h-full flex-col rounded-3xl border border-white/10 bg-white/95 p-8 text-left shadow-xl shadow-main/20 transition duration-300 hover:-translate-y-2 hover:shadow-2xl "
                  style={{ animation: `fadeDown 0.9s ${index * 0.12}s both` }}
                >
                  <div className="flex items-center gap-4">
                    <div className="flex h-14 w-14 items-center justify-center rounded-2xl border border-main/30 bg-main/10 text-sm font-bold text-main" aria-hidden="true">
                      {testimonial.name
                        .split(" ")
                        .map((part) => part[0])
                        .join("")}
                    </div>
                    <div className="flex flex-col">
                      <span className="text-lg font-semibold text-gray-900 ">
                        {testimonial.name}
                      </span>
                      <span className="text-sm text-gray-500 ">
                        {testimonial.title[lang]}
                      </span>
                    </div>
                  </div>
                  <blockquote className="mt-6 text-base leading-relaxed text-gray-700 ">
                    “{testimonial.quote[lang]}”
                  </blockquote>
                  <div className="mt-6 rounded-2xl bg-main/10 p-5 text-sm text-main ">
                    {testimonial.service[lang]}
                  </div>
                </figure>
              ))}
            </div>

            <div className="mt-16 rounded-3xl border border-white/15 bg-gradient-to-br from-white/10 via-white/5 to-sky-200/10 p-8 shadow-2xl shadow-main/20 backdrop-blur-sm">
              <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1.1fr,1fr]">
                <div>
                  <h3 className="text-2xl font-bold text-white">
                    {t.testimonialsServicesTitle}
                  </h3>
                  <p className="mt-4 text-white/80">
                    {t.testimonialsServicesDesc}
                  </p>
                </div>
                <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2">
                  {serviceHighlights.map((service, index) => (
                    <div
                      key={service.title.en}
                      className="flex gap-4 rounded-2xl border border-white/10 bg-white/90 p-5 shadow-lg shadow-main/10 transition duration-300 hover:-translate-y-1 hover:shadow-2xl  "
                    >
                      <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-main/10 text-base font-semibold text-main ">
                        {String(index + 1).padStart(2, "0")}
                      </span>
                      <div>
                        <p className="text-sm font-semibold uppercase tracking-[0.2em] text-main">
                          {service.category[lang]}
                        </p>
                        <h4 className="mt-1 text-lg font-bold text-gray-900 ">
                          {service.title[lang]}
                        </h4>
                        <p className="mt-2 text-sm text-gray-600 ">
                          {service.description[lang]}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="relative overflow-hidden py-20 sm:py-32  text-white">
          <div className="pointer-events-none absolute inset-0 from-white/10 via-transparent to-white/5 opacity-80"></div>
          <div className="pointer-events-none absolute -top-32 left-1/3 h-72 w-72 -translate-x-1/2 rounded-full bg-white/25 blur-3xl"></div>
          <div className="pointer-events-none absolute -bottom-32 right-1/4 h-64 w-64 rounded-full bg-sky-300/40 blur-3xl"></div>
          <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-b from-white/10 via-transparent to-white/10 opacity-40"></div>
          <div className="relative container mx-auto px-4">
            <div className="relative isolate overflow-hidden  bg-main rounded-3xl border border-white/15 bg-white/[0.08] p-8 sm:p-12 shadow-2xl shadow-main/30 backdrop-blur-xl">
              <div className="pointer-events-none absolute inset-x-12 -top-40 h-56 rounded-full bg-white/20 blur-3xl"></div>
              <div className="pointer-events-none absolute -bottom-48 left-1/2 h-64 w-64 -translate-x-1/2 rounded-full bg-sky-300/30 blur-3xl"></div>
              <div className="relative flex flex-col items-center gap-8 text-center">
                <span
                  className={`inline-flex items-center gap-3 rounded-full border border-white/25 bg-white/15 px-4 py-1 text-[0.75rem] font-semibold text-white/90 ${ctaBadgeClass}`}
                >
                  <span className="flex h-6 w-6 items-center justify-center rounded-full bg-white/20">
                    <svg
                      aria-hidden="true"
                      className="h-3.5 w-3.5 text-main"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M12 3l2.54 5.44 5.96.5-4.5 3.88 1.36 5.82L12 15.77 6.64 18.64l1.36-5.82-4.5-3.88 5.96-.5L12 3z" />
                    </svg>
                  </span>
                  {ctaBadgeLabel}
                </span>
                <div className="space-y-4 sm:space-y-6">
                  <h2 className="text-3xl md:text-4xl font-bold leading-tight">
                    {t.ready}
                  </h2>
                  <p className="text-base md:text-lg text-white/90 max-w-3xl mx-auto">
                    {t.readyDesc}
                  </p>
                </div>
                <div className="flex flex-col items-center gap-4 sm:flex-row">
                  <a
                    href="/auth/register"
                    className="group inline-flex items-center justify-center gap-2 rounded-full bg-white px-8 py-3 text-sm font-semibold text-main shadow-xl shadow-main/30 transition hover:-translate-y-0.5 hover:bg-slate-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                  >
                    {t.getStarted}
                    <svg
                      aria-hidden="true"
                      className="h-4 w-4 transition duration-300 group-hover:translate-x-1"
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                    >
                      <path d="M5 12h14M13 6l6 6-6 6" />
                    </svg>
                  </a>
                  <a
                    href="#pricing"
                    className="inline-flex items-center justify-center gap-2 rounded-full border border-white/40 px-8 py-3 text-sm font-semibold text-white/90 transition hover:border-white hover:bg-white/10"
                  >
                    {ctaSecondaryLabel}
                    <svg
                      aria-hidden="true"
                      className="h-4 w-4"
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                    >
                      <path d="M5 12h14M13 6l6 6-6 6" />
                    </svg>
                  </a>
                </div>
                <ul className="flex w-full flex-col items-center gap-3 text-sm text-white/80 sm:flex-row sm:flex-wrap sm:justify-center">
                  {ctaHighlights.map((item) => (
                    <li
                      key={item}
                      className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-4 py-2 backdrop-blur-sm"
                    >
                      <span className="flex h-5 w-5 items-center justify-center rounded-full bg-main/20">
                        <svg
                          aria-hidden="true"
                          className="h-3 w-3 text-white"
                          fill="none"
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2.5"
                          viewBox="0 0 24 24"
                        >
                          <path d="M5 13l4 4L19 7" />
                        </svg>
                      </span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>
      </main>
      {/* <LandingFooter /> */}
      < LandingFooter />
    </div>
  );
}

function PricingCard({
  title,
  price,
  period,
  perks = [],
  hot,
  tier = "basic",
  featured,
  note,
  labels = translations.en,
  delay = 0,
  ctaHref = "/auth/register",
}) {
  const accentMap = {
    basic: "from-sky-400 via-blue-500 to-blue-600",
    pro: "from-indigo-400 via-purple-500 to-indigo-600",
    business: "from-emerald-400 via-teal-500 to-emerald-600",
  };

  const accent = accentMap[tier] || accentMap.basic;
  return (
    <div
      className={`group relative isolate flex h-full flex-col overflow-hidden rounded-3xl border border-slate-200/60 bg-white/80 p-8 shadow-lg shadow-main/5 transition duration-300 ease-out hover:-translate-y-2 hover:shadow-2xl hover:shadow-main/20  ${
        featured ? "ring-2 ring-main/60" : ""
      }`}
      style={{ animation: `fadeDown 0.9s ${delay}s both` }}
    >
      <div
        aria-hidden="true"
        className={`absolute inset-0 -z-10 bg-gradient-to-br opacity-0 transition duration-300 group-hover:opacity-100`}
      ></div>
      <div
        aria-hidden="true"
        className="absolute inset-0 -z-20 bg-white/60 backdrop-blur-xl transition duration-300 group-hover:bg-white/70 "
      ></div>

      <div className="flex items-start justify-between">
        <div>
         
          <h3 className="mt-2 text-xl font-bold text-gray-900 ">{title}</h3>
        </div>
        {hot && (
          <span className="inline-flex items-center rounded-full bg-gradient-to-br  bg-blue-600 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-white shadow-lg shadow-main/20">
            {hot}
          </span>
        )}
      </div>

      <div className="mt-6 flex flex-col items-center text-center">
        <div className="flex items-baseline gap-2">
          <span className="text-4xl font-black text-gray-900 ">{price}</span>
          <span className="text-sm font-semibold uppercase text-gray-500 ">{period}</span>
        </div>
        {note && (
          <p className="mt-3 max-w-xs text-sm text-gray-500">
            {note}
          </p>
        )}
      </div>

      <div className="mt-6 h-px w-full bg-gradient-to-r from-transparent via-slate-200 to-transparent "></div>

  <ul className="mt-6 space-y-3 text-sm text-gray-600 ">
        {perks.map((perk, index) => (
          <li key={index} className="flex items-center gap-3">
            <span className={`flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-gradient-to-br ${accent} text-white shadow-sm shadow-main/20`}>
              <svg
                aria-hidden="true"
                className="h-4 w-4"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2.5"
                viewBox="0 0 24 24"
              >
                <path d="M5 13l4 4L19 7" />
              </svg>
            </span>
            <span className="flex flex-wrap items-baseline gap-1">
              <span>{perk.label}</span>
              {perk.value && (
                <span className="font-semibold text-gray-900 ">{perk.value}</span>
              )}
            </span>
          </li>
        ))}
      </ul>

      <a
        href={ctaHref}
        className="mt-8 inline-flex w-full items-center justify-center gap-2 rounded-full border border-transparent bg-main px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-main/30 transition hover:bg-main/90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-main"
      >
        {labels.getStarted}
        <svg
          aria-hidden="true"
          className="h-4 w-4"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          viewBox="0 0 24 24"
        >
          <path d="M5 12h14M13 6l6 6-6 6" />
        </svg>
      </a>
    </div>
  );
}

// Add AnimatedCounter component at the bottom of the file
function AnimatedCounter({ value, locale = "en-US" }) {
  // Animate numeric prefix and preserve original suffix (e.g., "K+" or "sec").
  const parsed = React.useMemo(() => {
    if (typeof value === "number") {
      return { target: value, decimals: 0, suffix: "" };
    }
    if (typeof value === "string") {
      const match = value.match(/^(\d+(?:\.\d+)?)/);
      if (match) {
        const decimals = match[1].includes(".") ? match[1].split(".")[1].length : 0;
        return {
          target: parseFloat(match[1]),
          decimals,
          suffix: value.slice(match[1].length),
        };
      }
    }
    return null;
  }, [value]);

  const target = parsed?.target ?? null;
  const decimals = parsed?.decimals ?? 0;
  const suffix = parsed?.suffix ?? "";
  const [count, setCount] = React.useState(0);
  const formatter = React.useMemo(
    () =>
      new Intl.NumberFormat(locale, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      }),
    [locale, decimals]
  );

  React.useEffect(() => {
    if (target === null || Number.isNaN(target)) {
      return;
    }
    setCount(0);
    const duration = 900;
    const step = target / (duration / 16);
    let current = 0;
    let raf;

    const tick = () => {
      current += step;
      if (current < target) {
        setCount(current);
        raf = requestAnimationFrame(tick);
      } else {
        setCount(target);
      }
    };

    tick();
    return () => raf && cancelAnimationFrame(raf);
  }, [target]);

  if (target === null || Number.isNaN(target)) {
    return <>{value}</>;
  }

  const clamped = Math.min(count, target);
  const formatted = formatter.format(decimals ? clamped : Math.round(clamped));

  return <>{`${formatted}${suffix}`}</>;
}
